import React, { useEffect, useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";
import { user_challenge_opportunity_list } from "../../user/user.api";
import "../careers/tenders.css";

function ChallengesOpportunities(props) {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const parseDueDate = (value) => {
    if (!value) return null;
    const str = String(value).trim();
    if (!str) return null;

    // Handle known formats explicitly first to avoid browser-dependent parsing
    // (e.g. new Date("01/11/2026") may be treated as mm/dd/yyyy in some browsers)
    const slashParts = str.split("/");
    if (slashParts.length === 3) {
      const [a, b, c] = slashParts;
      // yyyy/mm/dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd/mm/yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    const dashParts = str.split("-");
    if (dashParts.length === 3) {
      const [a, b, c] = dashParts;
      // yyyy-mm-dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd-mm-yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    // Try native parsing next (handles ISO like 2026-04-29T10:20:30Z)
    const native = new Date(str);
    if (!Number.isNaN(native.getTime())) return native;

    return null;
  };

  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  const visibleData = data.filter((item) => {
    const due = parseDueDate(item?.due_date);
    if (!due) return true;
    due.setHours(0, 0, 0, 0);
    return due >= todayStart;
  });

  useEffect(() => {
    user_challenge_opportunity_list().then((res) => {
      const rows = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
          ? res?.data
          : [];

      const mapped = rows
        .filter(
          (x) =>
            String(x?.status).toLowerCase() === "approved" ||
            String(x?.status) === "1"
        )
        .map((item) => ({
          ...item,
          opportunity:
            item?.market_analysis_opportunity?.opportunity ??
            item?.market_analysis_opportunity_name ??
            item?.opportunity ??
            "",
          image: item?.image || "",
          brochure: item?.brochure || "",
        }));

      setData(mapped);
      setCurrentPage(1);
    });
  }, []);

  const totalItems = visibleData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = visibleData.slice(indexOfFirstItem, indexOfLastItem);

  const handleLink = (linkurl) => {
    if (!linkurl) return;
    const urlLower = String(linkurl).toLowerCase();
    const urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };

  return (
    <div className="tender bg-tender">
      <div>
        <div className="dash-banner ">
          <div className="tix">
            {props.state.language === "ma" ? "ചലഞ്ചുകളും അവസരങ്ങളും" : "Challenges/Opportunities"}
          </div>
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container p-50">
        <div className="bg-white">
          <div className="row tender-box">
            {currentItems.length > 0 ? (
              <>
                {currentItems.map((card, index) => (
                  <div
                    className="bg-tender p-30 " style={{ minHeight: "300px" }}
                    key={card?.id ?? card?._id ?? index}
                  >
                    <div className="tender-title mb-2">
                      <p className="head " style={{ overflowWrap: "break-word" }}>
                        <u>{card?.title || "-"}</u>
                      </p>
                    </div>

                    {card?.opportunity && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "അവസരം" : "Opportunity"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>{card?.opportunity}</p>
                        </div>
                      </div>
                    )}

                    {card?.title && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "തലക്കെട്ട്" : "Title"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>{card?.title}</p>
                        </div>
                      </div>
                    )}

                    {card?.description && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "വിവരണം" : "Description"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>{card?.description}</p>
                        </div>
                      </div>
                    )}

                    {card?.due_date && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "അവസാന തീയതി" : "Due Date"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>{card?.due_date}</p>
                        </div>
                      </div>
                    )}

                    {card?.site_url && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx overf">
                          <p>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLink(card.site_url);
                              }}
                              className="break_link"
                            >
                              {props.state.language === "ma" ? "കാണുക" : "Open"}
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                    {card?.brochure && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "ബ്രോഷർ" : "Reference Document"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx overf">
                          <p>
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                const url = card.brochure;
                                const filename =
                                  url.split("/").pop() || "brochure.pdf";
                                const link = document.createElement("a");
                                link.href = url;
                                link.download = filename;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                              className="break_link"
                              style={{ cursor: "pointer" }}
                            >
                              {props.state.language === "ma" ? "ഡൗൺലോഡ്" : "Download"}
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                    {card?.image && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>
                            {props.state.language === "ma" ? "ചിത്രം" : "Image"}
                          </p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <img
                            src={card.image}
                            alt=""
                            style={{
                              width: "140px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-4 px-4 w-100 flex-wrap pagination-container" style={{ gap: '15px', paddingBottom: '30px' }}>
                    <div className="text-muted" style={{ fontSize: "14px" }}>
                      {props.state.language === "ma" ? (
                        <>കാണിക്കുന്നത് <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> (ആകെ <b>{totalItems}</b> അവസരങ്ങൾ)</>
                      ) : (
                        <>Showing <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> of <b>{totalItems}</b> Opportunities</>
                      )}
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <button
                        className="btn btn-outline-primary btn-sm px-3 py-2"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                        style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                      >
                        <i className="fa fa-chevron-left mr-1"></i> {props.state.language === "ma" ? "മുമ്പത്തെ" : "Prev"}
                      </button>
                      
                      {(() => {
                        const pages = [];
                        const maxVisible = 5;
                        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                        let end = Math.min(totalPages, start + maxVisible - 1);
                        if (end - start + 1 < maxVisible) {
                          start = Math.max(1, end - maxVisible + 1);
                        }
                        
                        if (start > 1) {
                          pages.push(
                            <button
                              key={1}
                              className={`btn btn-sm px-3 py-2 ${currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"}`}
                              onClick={() => setCurrentPage(1)}
                              style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                            >
                              1
                            </button>
                          );
                          if (start > 2) {
                            pages.push(<span key="dots-start" className="px-2 align-self-center text-muted">...</span>);
                          }
                        }
                        
                        for (let i = start; i <= end; i++) {
                          pages.push(
                            <button
                              key={i}
                              className={`btn btn-sm px-3 py-2 ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
                              onClick={() => setCurrentPage(i)}
                              style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                            >
                              {i}
                            </button>
                          );
                        }
                        
                        if (end < totalPages) {
                          if (end < totalPages - 1) {
                            pages.push(<span key="dots-end" className="px-2 align-self-center text-muted">...</span>);
                          }
                          pages.push(
                            <button
                              key={totalPages}
                              className={`btn btn-sm px-3 py-2 ${currentPage === totalPages ? "btn-primary text-white" : "btn-outline-primary"}`}
                              onClick={() => setCurrentPage(totalPages)}
                              style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                            >
                              {totalPages}
                            </button>
                          );
                        }
                        return pages;
                      })()}

                      <button
                        className="btn btn-outline-primary btn-sm px-3 py-2"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                        style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                      >
                        {props.state.language === "ma" ? "അടുത്തത്" : "Next"} <i className="fa fa-chevron-right ml-1"></i>
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChallengesOpportunities;
